import { CompanyInvitationRole } from '__generated__/GQL';

import { GetBeneficiariesDataQuery } from '../../graphql/queries/getBeneficiariesData.gql';

export const getCurrentUserBeneficiary = (
  data: GetBeneficiariesDataQuery['viewer'],
) => {
  const currentUserBeneficiary = data.company.legalBeneficiaries.find(
    ({ isCurrentUser }) => isCurrentUser,
  );

  return currentUserBeneficiary
    ? {
        ...currentUserBeneficiary,
        // TODO(LED-1784): The legal beneficiary of the current user has null values for firstName
        // and lastName, this is a patch until we fix that
        firstName: currentUserBeneficiary.firstName || data.profile.firstName,
        lastName: currentUserBeneficiary.lastName || data.profile.lastName,
      }
    : null;
};

export const getLegalBeneficiariesWithoutCurrentUser = (
  data: GetBeneficiariesDataQuery['viewer'],
) => {
  return (
    data.company.legalBeneficiaries.filter(
      ({ isCurrentUser }) => !isCurrentUser,
    ) ?? []
  );
};

export const getTotalBeneficiaries = (
  data: GetBeneficiariesDataQuery['viewer'],
) => {
  return data.company.legalBeneficiaries.filter(
    (legalBeneficiary) => !legalBeneficiary.isCurrentUser,
  ).length;
};

export const hasAccountHolderInvitation = (
  data: GetBeneficiariesDataQuery['viewer'],
) => {
  return data.company.legalBeneficiaries.some(
    (beneficiary) =>
      beneficiary.invitation?.role === CompanyInvitationRole.AccountHolder,
  );
};
